export const configuration = {
  dailyGoal: 15,
  dailyTasksToComplete: 2,
  playersPerPage: 8,
  activeProgramName: 'Active ROM', // TODO: This needs removed and replaced with a more permanent solution
  passiveProgramName: 'Passive ROM', // TODO: This needs removed and replaced with a more permanent solution
};
